import tree from 'state';


export function toggleExpand() {
  tree.merge(['sidebarPage'], {
    sidebarExpanded: !tree.get(['sidebarPage', 'sidebarExpanded']) 
  });
}
